/**
 * HighResTimestamp
 * A class to represent a high resolution timestamp.
 * Wraps performance.now to prevent illegal use of the raw timestamp.
 * For example, this code would be incorrect new Date() - performance.now().
 */
export class HighResTimestamp {
  constructor(public readonly timestamp: DOMHighResTimeStamp = performance.now()) {}

  /**
   * Get the raw timestamp value.
   */
  get value(): DOMHighResTimeStamp {
    return this.timestamp;
  }

  /**
   * Calculate the difference between this timestamp and another.
   * @param other - The other HighResTimestamp to calculate the difference with.
   * @returns The difference in milliseconds as a HighResTimestamp.
   */
  difference(other: HighResTimestamp): HighResTimestamp {
    return new HighResTimestamp(this.timestamp - other.timestamp);
  }
}
